// VUEX module 'app'

const validShopListTabs = ['list', 'map']

export const app = {
  namespaced: true,
  state: {
    navDrawer: false,
    shopListFilter: {
      category: [],
      shipping: null,
      text: ''
    },
    shopListTab: validShopListTabs[0]
  },
  getters: {
    showNavDrawer: state => state.navDrawer,
    shopListTab: state => state.shopListTab,
    shopListFilter: state => state.shopListFilter
  },
  mutations: {
    openNavDrawer: state => state.navDrawer = true,
    closeNavDrawer: state => state.navDrawer = false,
    toggleNavDrawer: state => state.navDrawer = !state.navDrawer,
    setNavDrawerState: (state, payload) => state.navDrawer = !!payload,
    resetFilter: state => {
      state.shopListFilter.category = []
      state.shopListFilter.shipping = null
      state.shopListFilter.text = ''
    },
    setFilter: (state, payload = {}) => {
      if (typeof payload.text === 'string') {
        state.shopListFilter.text = payload.text
      }

      if (Array.isArray(payload.category)) {
        state.shopListFilter.category = payload.category
      }

      if (!isNaN(payload.shipping)) {
        state.shopListFilter.shipping = payload.shipping
      }
    },
    setShopListTab (state, payload) {
      if (validShopListTabs.indexOf(payload) > -1) {
        state.shopListTab = payload
      } else {
        state.shopListTab = validShopListTabs[0]
      }
    },
    toggleShopListTab (state) {
      const idx = validShopListTabs.indexOf(state.shopListTab)
      if (idx === validShopListTabs.length - 1) {
        state.shopListTab = validShopListTabs[0]
      } else {
        state.shopListTab = validShopListTabs[idx + 1]
      }
    }
  },
  actions: {
  },
  modules: {
  }
}
